import React from 'react';
import { brand } from '../../config/brand';
import RobotLogo from '../RobotLogo/RobotLogo';
import './Footer.css';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner container">
        {/* Logo + tagline */}
        <div className="footer__brand">
          <a href="#hero" className="footer__logo" aria-label="ZinifyLabs home">
            <RobotLogo size={26} className="footer__logo-icon" />
            {brand.agency.name}
          </a>
          <p className="footer__tagline">
            AI engineering studio · {brand.agency.region}, {brand.agency.compliance} · Founded by{' '}
            {brand.founder.name}
          </p>
        </div>

        {/* Nav links */}
        <nav className="footer__nav" aria-label="Footer navigation">
          {brand.nav.links.map((link) => (
            <a key={link.href} href={link.href} className="footer__nav-link">
              {link.label}
            </a>
          ))}
        </nav>

        {/* Social */}
        <div className="footer__social">
          {brand.social.linkedin && (
            <a
              href={brand.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
              aria-label="LinkedIn"
              id="footer-linkedin"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          )}
          {brand.social.github && (
            <a
              href={brand.social.github}
              target="_blank"
              rel="noopener noreferrer"
              className="footer__social-link"
              aria-label="GitHub"
              id="footer-github"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd"/></svg>
            </a>
          )}
          <a
            href={`mailto:${brand.agency.email}`}
            className="footer__social-link"
            aria-label="Email"
            id="footer-email"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 01-2.06 0L2 7"/></svg>
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p className="footer__copy">© {year} {brand.agency.legalName}. All rights reserved. Registered in Vilnius, Lithuania.</p>
          <p className="footer__built">
            {brand.agency.region} · {brand.agency.compliance} · {brand.agency.timezoneLabel}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
